<template>
	<div v-if="show" :class="slideInClass">
		<header class="titled">
			<div>
				<h1>Termine</h1>
			</div>
			<div class="close-container">
				<a href="#" @click.prevent="close">
					<Icon icon="close"/>
				</a>
			</div>
		</header>
		<main class="scrollbar-check">
			<Loading v-if="loading"/>
			<template v-else>
				<div v-if="potentialDates.length === 0">Es sind derzeit keine Termine vorhanden.</div>
				<template v-else>
					<Calendar
						is-expanded
						:attributes="calendarAttributes"
						@dayclick="onDayClick"
					>
						<template #day-content="{ day, attributes }">
							<a
								href="#"
								:class="{
									'vc-day-content-custom': true,
									'vc-day-content-custom--in-month': day.inMonth,
									'vc-day-content-custom--selected': isSelected(day)
								}"
								@click.prevent="onDayClick(day)"
							>
								{{ day.label }}
								<span v-if="getDatesCount(day) > 0" class="count-bubble">{{ getDatesCount(day) }}</span>
							</a>
						</template>
					</Calendar>
					<div v-if="selectedDate">
						<div v-if="datePotentialDates.length === 0" class="mt-4 font-weight-extra-bold">
							Keine Termine vorhanden am {{ selectedDate | date }}.
						</div>
						<div v-else class="communication-appointment-fan--appointments">
							<PotentialDate
								v-for="potentialDate in datePotentialDates"
								:key="potentialDate.id"
								:potential-date="potentialDate"
								:list-type="listType"
								@change="loadPotentialDates"
							/>
						</div>
					</div>
				</template>
			</template>
		</main>
		<footer></footer>
	</div>
</template>

<script>
import Calendar from 'v-calendar/lib/components/calendar.umd'
import {mapActions, mapState} from "vuex";
import Icon from "@/vue/icon/Icon"
import Loading from "@/vue/common/Loading";
import Button from "@/vue/common/Button";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/communication/appointment";
import GetList from "@/api/communication/appointment/GetList";
import {DateTime} from "luxon";
import {formatDate} from "@/helper/Date";
import PotentialDate from "@/vue/communication/appointment/fan/PotentialDate";

export default {

	components: {
		PotentialDate,
		Button,
		Loading,
		Icon,
		Calendar,
	},

	data ()
	{
		return {
			loading: true,
			potentialDates: undefined,
			selectedDate: undefined,
		};
	},

	computed: {
		...mapState('communication/appointment', [
			'show',
			'listType',
		]),
		...mapState('layout', ['fanLevelClasses']),
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['slide-in', 'slide-in-small', 'communication-appointment-fan']
			});
		},
		calendarAttributes ()
		{
			const dates = _
				.chain(this.potentialDates)
				.map(a => DateTime.fromISO(a.timeStamp))
				.map(date => date.toJSDate())
				.uniq()
				.value();

			return [{
				dates
			}];
		},
		datePotentialDates ()
		{
			if (!this.selectedDate)
			{
				return undefined;
			}

			return _
				.chain(this.potentialDates)
				.filter(potentialDate =>
				{
					return formatDate(DateTime.fromISO(potentialDate.timeStamp)) === formatDate(this.selectedDate);
				})
				.sort((a, b) =>
				{
					const timeStampA = DateTime.fromISO(a.timeStamp).toISOTime();
					const timeStampB = DateTime.fromISO(b.timeStamp).toISOTime();

					return timeStampA === timeStampB
						? 0
						: (timeStampA < timeStampB ? -1 : 1);
				})
				.value();
		}
	},

	methods: {
		...mapActions('communication/appointment', [
			'close'
		]),
		async loadPotentialDates ()
		{
			this.loading = true;

			const response = await new GetList()
				.call();

			this.potentialDates = response.data;

			this.loading = false;
		},
		getDatesCount (day)
		{
			return _
				.filter(
					this.potentialDates || [],
					potentialDate =>
					{
						return formatDate(DateTime.fromISO(potentialDate.timeStamp)) === formatDate(DateTime.fromJSDate(day.date))
							&& !potentialDate.pastDue;
					}
				)
				.length;
		},
		onDayClick (data)
		{
			this.selectedDate = DateTime.fromObject({
				year: data.year,
				month: data.month,
				day: data.day,
			});
		},
		isSelected (day)
		{
			if (!day || !this.selectedDate)
			{
				return false;
			}

			return formatDate(this.selectedDate) === formatDate(DateTime.fromJSDate(day.date));
		}
	},

	watch: {
		show (show)
		{
			if (show)
			{
				this.loadPotentialDates();
			}
		}
	}
}
</script>
